$ = require('jquery')

require('slick-carousel/slick/slick.js')

module.exports =
	init: (payload) ->
		{$target} = payload

		$('.b-product__images-m').each(->
			$this = $(@)
			$scroll = $this.find('.b-product__images-m__scroll')
			$pages = $this.find('.pages')
			$prev = $this.find('.prev')
			$next = $this.find('.next')

			$scroll.slick(
				infinite: false
				dots: true
				appendDots: $pages
				prevArrow: $prev
				nextArrow: $next
				mobileFirst: true
				slidesToShow: 1
				slidesToScroll: 1
			)
		)

		$('.c-recommendations').each(->
			$this = $(@)
			$scroll = $this.find('.c-recommendations__list')
			$pages = $this.find('.pages')
			$prev = $this.find('.prev')
			$next = $this.find('.next')

			$scroll.slick(
				infinite: false
				dots: true
				appendDots: $pages
				prevArrow: $prev
				nextArrow: $next
				mobileFirst: true
				slidesToShow: 1
				slidesToScroll: 1
				responsive: [
					{
						breakpoint: 479
						settings: {
							slidesToShow: 2
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 749
						settings: {
							slidesToShow: 3
							slidesToScroll: 1
						}
					}
					{
						breakpoint: 999
						settings: {
							slidesToShow: 4
							slidesToScroll: 1
						}
					}
				]
			)
		)



// WEBPACK FOOTER //
// ./src/js/components/carousel.coffee